import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-details-view',
  templateUrl: './price-details-view.component.html',
  styleUrls: ['./price-details-view.component.scss'],
})
export class PriceDetailsViewComponent implements OnInit {
  @Input() price: string;
  @Input() paymentMethod: string;
  @Input() suggestedPrice: string;

  paymentMethodMapper = {
    "checkatdelivery": "CHOD",
  };

  paymentMethodFormatted: string;

  ngOnInit() {
    let paymentMethodFormatted = null;

    if (this.paymentMethod) {
      paymentMethodFormatted = this.paymentMethodMapper[this.paymentMethod.toLocaleLowerCase().replace(/\s/g,'')];
    }
    
    this.paymentMethodFormatted = paymentMethodFormatted ? paymentMethodFormatted : this.paymentMethod;
  }
}

